<template>
  <form id="form">
    <div v-if="loaded" class="card card-custom gutter-b">
      <div class="card-header">
        <div class="card-title">
          <h3 class="card-label">آپلود فایل و افزودن لینک</h3>
        </div>
      </div>
      <div class="card-body">
        <p>
          یک یا چند فایل آپلود و یا لینک ویدیوهای خود را وارد نمایید تا به ترتیب
          پخش شوند.
        </p>
        <p>
          توجه کنید که در صورت استفاده از لینک پخش زنده٬ لینک باید در انتهای
          لیست قرار بگیرد.
        </p>

        <button
          type="button"
          class="btn btn-primary mb-5"
          @click="form.inputs.push({ type: '2', content: '' })"
        >
          <i class="fas fa-plus"></i> افزودن
        </button>

        <div v-show="form.type === '2'">
          <div
            v-for="(item, i) in form.inputs"
            :key="i + 'fl'"
            class="form-group"
          >
            <div class="input-group mb-3">
              <div class="input-group-prepend">
                <select
                  class="btn btn-primary p-1"
                  type="button"
                  style="border-bottom-left-radius: 0; border-top-left-radius: 0"
                  v-model="form.inputs[i].type"
                  @change="form.inputs[i].content = ''"
                >
                  <option value="1">فایل</option>
                  <option value="2">لینک</option>
                </select>
              </div>
              <div v-if="item.type === '1'" class="custom-file">
                <input
                  type="file"
                  class="custom-file-input"
                  id="program_file"
                  @change="fileChanged($event, i)"
                  accept="video/*"
                />
                <label class="custom-file-label" for="program_file">
                  <span v-if="item.content !== ''">
                    {{ item.content }}
                  </span>
                  <span v-else>
                    انتخاب کنید.
                  </span>
                </label>
              </div>
              <input
                v-if="item.type === '2'"
                type="text"
                name="link_address"
                v-model="form.inputs[i].content"
                class="form-control"
                dir="ltr"
              />
              <div class="input-group-append">
                <span
                  class="input-group-text bg-danger text-white"
                  @click="form.inputs.splice(i, 1)"
                >
                  x
                </span>
              </div>
              <div class="input-group-append">
                <span
                  class="input-group-text bg-primary text-white"
                  @click="up(i)"
                >
                  <i class="fas fa-arrow-up"></i>
                </span>
              </div>
              <div class="input-group-append">
                <span
                  class="input-group-text bg-primary text-white"
                  @click="down(i)"
                >
                  <i class="fas fa-arrow-down"></i>
                </span>
              </div>
            </div>
            <div
              class="progress mb-3"
              v-if="
                programsFilesProgress[program.id + '_' + i] !== undefined &&
                  programsFilesProgress[program.id + '_' + i] > 0
              "
            >
              <div
                class="progress-bar progress-bar-striped bg-info"
                role="progressbar"
                v-bind:aria-valuenow="
                  programsFilesProgress[program.id + '_' + i]
                "
                aria-valuemin="0"
                aria-valuemax="100"
                v-bind:style="{
                  width: programsFilesProgress[program.id + '_' + i] + '%'
                }"
              >
                {{ programsFilesProgress[program.id + "_" + i] }}%
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </form>
</template>

<script>
import { SET_BREADCRUMB } from "@/core/services/store/breadcrumbs.module";
import { SET_ACTIONS } from "@/core/services/store/actions.module";
import {
  FETCH_PROGRAM,
  UPDATE_PROGRAM,
  UPLOAD_PROGRAM_FILE
} from "@/core/services/store/programs.module";
import formValidation from "@/assets/plugins/formvalidation/dist/es6/core/Core";
import Trigger from "@/assets/plugins/formvalidation/dist/es6/plugins/Trigger";
import Bootstrap from "@/assets/plugins/formvalidation/dist/es6/plugins/Bootstrap";
import _ from "lodash";

import { mapGetters } from "vuex";

export default {
  name: "programs-show",
  data() {
    return {
      loaded: false,
      isCompany: this.$route.name.startsWith("company"),
      isAdmin: this.$route.name.startsWith("admin"),
      form: {}
    };
  },
  beforeMount() {
    this.loaded = false;

    this.$store
      .dispatch(FETCH_PROGRAM, this.$route.params.id)
      .then(() => {
        this.loaded = true;
        this.setBreadcrumbs();
        this.setActions();
      })
      .catch(() => {
        this.loaded = true;
      });
  },
  mounted() {
    this.eventHub.$on("edit-program-event", this.save);
    this.eventHub.$on("delete-program-event", this.deleteProgram);

    this.fv = formValidation(document.getElementById("form"), {
      fields: {
        name: {
          validators: {
            notEmpty: {
              message: "نام صحیح نیست"
            },
            stringLength: {
              min: 5,
              max: 128,
              message: "نام صحیح نیست"
            }
          }
        }
      },
      plugins: {
        trigger: new Trigger(),
        bootstrap: new Bootstrap()
      }
    });
  },
  beforeDestroy() {
    this.eventHub.$off(["edit-program-event", "delete-program-event"]);
    document.getElementById("edit-program-btn").disabled = false;
  },
  watch: {
    originalForm: {
      handler() {
        this.form = _.cloneDeep(this.originalForm);
      },
      deep: true
    },

    form: {
      handler() {
        document.getElementById("edit-program-btn").disabled = _.isEqual(
          this.form,
          this.originalForm
        );
      },
      deep: true
    }
  },
  methods: {
    fileChanged(e, i) {
      if (e.target.files && e.target.files[0]) {
        e.target.nextElementSibling.classList.add("selected");

        let submitBtn = document.getElementById("edit-program-btn");
        this.disableBtn(submitBtn);

        this.$store
          .dispatch(UPLOAD_PROGRAM_FILE, {
            program: this.program.id,
            i: i,
            file: e.target.files[0]
          })
          .then(name => {
            this.form.inputs[i].content = name;
            this.enableBtn(submitBtn);
          })
          .catch(() => {
            this.enableBtn(submitBtn);
          });
      } else {
        e.target.nextElementSibling.classList.remove("selected");
        this.form.inputs[i].content = "";
      }
    },
    setBreadcrumbs() {
      let programsRouteName = "programs-index";

      let items = [];
      if (this.isCompany) {
        programsRouteName = "company-programs-index";

        items.push({
          title: this.currentUserProperty.title ?? "شرکت",
          route: { name: "company-dashboard" }
        });
      }

      items.push({ title: "برنامه‌‌ها", route: { name: programsRouteName } });
      items.push({ title: this.program.name });

      this.$store.dispatch(SET_BREADCRUMB, items);
    },
    setActions() {
      this.$store.dispatch(SET_ACTIONS, {
        buttons: [
          {
            name: "ذخیره",
            event: "edit-program-event",
            class: "btn-primary",
            id: "edit-program-btn"
          }
        ]
      });
    },
    save() {
      let programLink = this.isCompany
        ? "company-programs-show"
        : "programs-show";

      this.fv.validate().then(status => {
        if (status === "Valid") {
          let submitBtn = document.getElementById("edit-program-btn");
          this.disableBtn(submitBtn);

          let formData = new FormData();
          let id = this.form.id;

          for (let key in this.form.inputs) {
            if (this.form.inputs[key].content) {
              formData.append(`inputs[]`, this.form.inputs[key].content);
            }
          }

          this.$store
            .dispatch(UPDATE_PROGRAM, { formData, id })
            .then(() => {
              this.$router.push({
                name: programLink,
                params: { id: this.program.id }
              });

              this.enableBtn(submitBtn);
            })
            .catch(() => {
              this.enableBtn(submitBtn);
            });
        } else if (status === "Invalid") {
          this.showError("لطفا فرم را به شکل صحیح کامل کنید");
        }
      });
    },
    up(i) {
      if (this.form.inputs && this.form.inputs[i] && i > 0) {
        let element = this.form.inputs.splice(i, 1)[0];
        this.form.inputs.splice(i - 1, 0, element);
      }
    },
    down(i) {
      if (
        this.form.inputs &&
        this.form.inputs[i] &&
        i < this.form.inputs.length
      ) {
        let element = this.form.inputs.splice(i, 1)[0];
        this.form.inputs.splice(i + 1, 0, element);
      }
    }
  },
  computed: {
    ...mapGetters(["currentUserProperty", "program", "programsFilesProgress"]),
    originalForm() {
      if (!this.loaded || this.program.name === undefined) {
        return;
      }

      let inputs = [];

      if (
        this.program.information["inputs"] &&
        this.program.information["inputs"].length
      ) {
        this.program.information["inputs"].forEach(input => {
          if (input.startsWith("http") || input.startsWith("rtmp")) {
            inputs.push({
              type: "2",
              content: input
            });
          } else {
            inputs.push({
              type: "1",
              content: input,
              disable: true
            });
          }
        });
      } else {
        inputs.push({
          type: "1",
          content: ""
        });
      }

      return {
        id: this.program.id,
        inputs: inputs,
        type: this.program.type.toString()
      };
    },
    isStopped() {
      return this.program.events && this.program.events.length;
    }
  }
};
</script>
